export * from './IconLayerYellow';
